export class GradientStrategy {
    constructor() {
        this.name = 'GradientStrategy';
        this.has_legend = true;
        this.is_gradient = true;
    }
    visible_inputs() {
        let inputs = [
            'colorize-field',
            'colorize-numcolors',
            'colorize-gradient',
            'colorize-startcolor',
            'colorize-endcolor',
            'colorize-strategy',
            'colorize-opacity'
        ];
        return inputs;
    }
    hex2rgb(hex) {
        let matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (!matches || matches.length < 4)
            throw new Error("Expected string of form #RRGGBB, got " + hex);
        return matches.slice(1, 4).map(v => parseInt(v, 16));
    }
    rgb2hex(rgb) {
        return '#' + rgb.map(v => parseInt(v).toString(16).padStart(2, '0')).join('');
    }
    hex2hsl(hex) {
        const rgb = this.hex2rgb(hex);
        let scaled = rgb.map(x => x / 255);
        let cmin = Math.min(...scaled);
        let cmax = Math.max(...scaled);
        let delta = cmax - cmin;
        let h = 0, s = 0, l = 0;
        if (delta === 0)
            h = 0;
        else if (cmax === scaled[0])
            h = ((scaled[1] - scaled[2]) / delta) % 6;
        else if (cmax === scaled[1])
            h = (scaled[2] - scaled[0]) / delta + 2;
        else
            h = (scaled[0] - scaled[1]) / delta + 4;
        h = Math.round(h * 60);
        if (h < 0)
            h += 360;
        l = (cmax + cmin) / 2;
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        return [h, s, l];
    }
    ;
    hsl2hex(hsl) {
        let h = hsl[0], s = hsl[1], l = hsl[2];
        s /= 100;
        l /= 100;
        let c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = l - c / 2, r = 0, g = 0, b = 0;
        if (0 <= h && h < 60) {
            r = c;
            g = x;
            b = 0;
        }
        else if (60 <= h && h < 120) {
            r = x;
            g = c;
            b = 0;
        }
        else if (120 <= h && h < 180) {
            r = 0;
            g = c;
            b = x;
        }
        else if (180 <= h && h < 240) {
            r = 0;
            g = x;
            b = c;
        }
        else if (240 <= h && h < 300) {
            r = x;
            g = 0;
            b = c;
        }
        else if (300 <= h && h < 360) {
            r = c;
            g = 0;
            b = x;
        }
        let r_s = Math.round((r + m) * 255).toString(16).padStart(2, '0');
        let g_s = Math.round((g + m) * 255).toString(16).padStart(2, '0');
        let b_s = Math.round((b + m) * 255).toString(16).padStart(2, '0');
        return '#' + r_s + g_s + b_s;
    }
    ;
}
